import type { Router } from 'vue-router'
import { scrollToLandingId } from '@/utils/landingScroll'

export function landingSectionHref(id: string): string {
  return `/#${id}`
}

export async function navigateToLandingSection(router: Router, id: string) {
  const hash = `#${id}`
  if (router.currentRoute.value.path === '/' && router.currentRoute.value.hash === hash) {
    scrollToLandingId(id)
    return
  }
  await router.push({ path: '/', hash })
}
